
import { check, commonApi } from '@/common/index'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { ValidateRequire, checkOne } from '@/common/utils/validate.js'
import {mapMutations} from 'vuex'
export default {
name: 'alterPassword',
components: {
XHeader,
Group,
XInput,
XButton
},
data() {
return {
oldPassword: '',
password: '',
repeatPassword: '',
isReady: true,
UUID: '',
}
},
created() {
this.UUID = this.$Cookies.get('UUID');
},
methods: {
...mapMutations(['SET_LOGIN_SHOW','set_bottom']),
haveComTotas(data,istype){
this.$vux.toast.show({ text: data,type: istype});
},
alterPassword() {
let params={
UUID: this.UUID,
oldPW: this.oldPassword,
newPW: this.password,
confirmNew: this.repeatPassword,
};
if(this.checkForm()&&this.isReady){
this.isReady = false;
commonApi.CONFIRM.updateLoginPassword(params).then(data=>{
this.isReady = true;
let timer = setTimeout(()=>{
this.loginOut()
clearTimeout(timer)
},1000)
const { title, successTips } = this.$t('mine').editPwd
this.$router.replace({path:'/My/AccountManat',query:{title,desc:successTips}});
}).catch(err=>{
this.isReady = true;
this.haveComTotas(err,'text')
})
}
},
loginOut() {
let UUID = this.$Cookies.get('UUID');

if(UUID){
this.$store.commit('del_token');
this.$api.post(this.$urls.USER.LOGINOUT,{UUID:UUID},(resp)=>{
if(resp.data.code===200){
this.$vux.toast.show({ text: this.$t('mine').editPwd.loginOut, type: 'text',});
this.$router.replace({path:'/'})
commonApi.USER.loginOut()
this.SET_LOGIN_SHOW();
}else {
let msg = resp.data.msg ? resp.data.msg :resp.data.message;
this.haveComTotas(msg,'cancel')
}
},err=>{})
}

},
checkForm(){





if (!checkOne(this.oldPassword)) {
this.haveComTotas(this.$t('Forms').pwdError,'cancel')
return
}





if (!checkOne(this.password)) {
this.haveComTotas(this.$t('Forms').pwdError,'cancel')
return
}

if (this.password === this.oldPassword) {
this.haveComTotas(this.$t('Forms').pwdDiff,'cancel')
return
}

if(!ValidateRequire(this.repeatPassword)){
this.haveComTotas(this.$t('Forms').repeatPwdPlace,'cancel')
return
}

if(this.repeatPassword !== this.password){
this.haveComTotas(this.$t('Forms').newDiff,'cancel')
return
}
return true
},
}
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/AccountManat/loginPossword.vue